module.exports = __webpack_public_path__ + "img/btn_menu_member.ff816bb9.svg";